<template>
  <div class="news-all">
    <div class="title">
      <span class="time">
        05.04
        <br />2018
      </span>
      <span class="tiel">美菜网刘传军获第32届“北京青年五四奖章”</span>
    </div>
    <div class="mat-content">
      <div class="tet-js">
        第三十二届“北京青年五四奖章”评选结果于五月四日揭晓。在获奖名单中，既能找到科技领域的翘楚，也能发现战斗一线的重案刑侦硬汉和技艺娴熟的工匠。美菜ceo刘传军与30名首都青年获此殊荣。《北京青年报》也推出新青年特刊，讲述30名获奖者在奋斗中用青春追逐梦想的故事。作为唯一一位获此殊荣的电商独角兽企业，刘传军说：“做美菜的创业，是我这辈子做得最有价值的事情，因为美菜真的可以帮助到很多农民，可以改变中国的农民和农村。”
        <br />
        <br />创立于2014年的美菜网， 致力于通过互联网的方式来改变农业、农村，改善农民生活。通过三四年的发展，截止到去年年底，美菜网现已覆盖全国近100个城市，销售额已超100亿，估值超过30亿美金。将互联网与传统农业相结合，美菜现已成为农业B2B领域的佼佼者，作为这家企业的掌舵者，刘传军对现代农业的发展理念与公司的发展之路相互并行。而他之所以致力于推动农业发展与其少年时代一次刻骨铭心的经历相关。
        <br />
        <br />刘传军的老家在山东沂蒙山，那里的山由石灰岩堆积而成，土质坚硬，山体牢固，虽不会发生滑坡、泥石流等地质灾害，却不利于保留水资源。在水资源匮乏的山里，耕地依山势开垦，水利设施难以建设，山区里的庄稼灌溉全指望老天。如遇上大旱，就要面临绝收的境地。
        <br />
        <br />刘传军15岁那年，家乡遭遇大旱。他家的玉米因天旱越来越蔫。玉米是家里一季的收成，也全家一年的收入。如果绝收，可以想象刘家当年的日子有多难熬，就连刘传军上学的费用也难以拿出。
        <br />
        <br />
      </div>
      <p align="center">
        <img src="@/assets/images/new-img/a11_3.jpg" width="640" />
      </p>
      <!-- <div class="tet-js" style="text-align: center">
            工信部副部长罗文 致辞
      </div>-->
      <div class="tet-js">
        在靠天吃饭的年代，浇地抗旱是农民们唯一能想到的解决办法。为救活玉米，15岁的刘传军跟着家人挑起扁担，从2公里以外的水源地将每桶重40斤重的水担上山，给每棵玉米浇水，足足浇了4遍，那个暑假，他一共担了400多担。可这并未改变刘家玉米的命运，玉米还是因为干旱几乎绝收。这一经历也深深地烙在刘传军的心里。
        <br />
        <br />后来，刘传军和多数上进青年一样，靠知识改变命运，走出了沂蒙山区。凭自身努力，他走进了中国科学院的研究室，成了一名研究空间物理学的硕士毕业生。在外人看来，刘传军是山沟里飞出来的金凤凰。2008年，在研究两年火星、一年月球，参与了神6神7的研发工作后，刘传军从中科院硕士研究生毕业，进入一家美国上市公司，从事IC芯片的研发工作，年薪十几万，可以解决北京户口。这是一份令人欣羡的工作，原本故事到这儿就足以让他成为别人眼中的传奇，但当年的“玉米欠收事件”却一直在刘传军心里挥之不去。
        <br />
        <br />
      </div>
      <div class="tet-js">
        2014年，他回到老家，发现当时玉米一斤只卖9毛，而早在1997年玉米就已经卖8毛5了。二十年间，种植成本显著提高，可田间地头的农产品价格却原地踏步。这让刘传军感到，中国农业需要一次变革，他迫切地想为中国这样一个大国的农业发展做点什么。而互联网的高速发展让他感到，农业也能借助互联网的力量来改变农村现状、改善农民生活，进而推动新时代的农业发展。
        <br />
        <br />于是，2014年6月，美菜网成立。其基本运作模式是用互联网将农村千家万户的农产品与城市千万中小餐厅连在一起。这一模式极大减少了农产品到餐桌的中间环节，既为餐厅节省人力物力，降低了采购成本，又方便了千万农户，解决了困扰他们多年的农产品卖难和价格低廉两大难题。也因此，美菜网一成立，即受到千千万万农户和城市中小餐厅的欢迎。
        <br />
        <br />公司业务规模扩大后，刘传军并没有忘记自己想为8亿农民谋幸福的初心。在他的主导下，美菜开启了“美菜SOS精准扶贫计划”。2018年3月13日，在得知四川省米易县有成千上万斤番茄滞销的消息后，刘传军亲自带队来到四川米易，当他看到河畔上被菜农倾倒掉的番茄时，久久不语。鲜红的番茄像菜农一年的血汗，一股股殷殷地注入河流。刘传军当即启动美菜网SOS全国采购计划，亲自解决了米易番茄滞销难题。
        <br />
        <br />截至目前，美菜已帮助内蒙古、山东、安徽等12个省市助销滞销农产品2445万斤，在贫困地区采购农产品超1亿斤。
        <br />
        <br />
        <p align="center">
          <img src="@/assets/images/new-img/a11_4.jpg" width="640" />
        </p>
        <br />“北京青年五四奖章”是共青团北京市委员会、北京市人力资源和社会保障局授予北京青年的最高荣誉。也是对新时代青年使命兼程，做奋斗者，做实干家的品格的肯定。那个带着初心，想为8亿农民谋幸福的刘传军和他的美菜，正在新时代中国特色社会主义思想的指引下，牢记使命，砥砺前行着。
        <br />
        <br />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "news-item"
};
</script>

<style lang="scss" scoped>
</style>
